import { useCallback } from 'react';
import { PlacesType } from 'react-tooltip';
import { useTooltipGroupContext } from '@/components/shared/tooltip/TooltipGroup';

type UseHeaderTruncationTooltipOptions = {
  tooltipPlace?: PlacesType;
};

export const useHeaderTruncationTooltip = (options?: UseHeaderTruncationTooltipOptions) => {
  const tooltipContext = useTooltipGroupContext();
  const resolvedTooltipPlace = options?.tooltipPlace ?? 'top';

  const handleHeaderMouseEnter = useCallback((e: React.MouseEvent<HTMLSpanElement>) => {
    const el = e.currentTarget;
    const isTruncated = el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
    if (!isTruncated) return;
    const textContent = el.textContent?.trim();
    if (!textContent) return;
    el.setAttribute('data-tooltip-content', textContent);
    el.setAttribute('data-tooltip-hidden', 'false');
  }, []);

  const handleHeaderMouseLeave = useCallback((e: React.MouseEvent<HTMLSpanElement>) => {
    e.currentTarget.setAttribute('data-tooltip-hidden', 'true');
    e.currentTarget.removeAttribute('data-tooltip-content');
  }, []);

  return { tooltipContext, resolvedTooltipPlace, handleHeaderMouseEnter, handleHeaderMouseLeave };
};
